import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import * as Yup from 'yup';
import { useAuth } from '../../../../../../hooks/Auth';
import { FiMail, FiRewind, FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk, FaUpload } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { FormHandles } from '@unform/core';
import { uuid } from 'uuidv4';
import { useSearch } from 'src/hooks/Search';
import { useParams } from 'react-router-dom';
import getValidationErrors from 'src/utils/getValidationErrors';
import FormComponent from 'src/pages/DashboardPages/core/components/FormComponentUnique';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();


  interface ICreateModule {
    lineData: Record<string, any>;
  }

  interface IParams {
    projectHash: string;
    eventHash: string;
  }

  const { reloadSearchAll } = useSearch();
  const { removeModal } = useModal();

  const { projectHash, eventHash } = useParams<IParams>();
  const { user } = useAuth();
  const key = uuid();

  const sendSingleEmailAgain = async (user_hash, index, length) => {


    try {
      await api.post(`/send-invitation-to-user/${lineData?.hash}/${user_hash}/yes`);

      addToast({ title: `${index + 1} / ${length} - Enviado com sucesso`, type: 'success' });

    }
    catch (err) {

      addToast({ title: `${index + 1} / ${length} - ${err?.response?.data?.message || 'Erro ao enviar'} `, type: 'error' })
    }

    return;

  }


  const sendConfirmation = async (items: Array<Record<string, any>>) => {

    let x = 0;

    while (x < items?.length) {



      const currentItem = items[x];

      const item: Record<string, any> = { ...currentItem, project_id: lineData?.project_id };
      if (item?.user_hash) {

        const student = await api.get('invitation-confirmation', { params: { where: { user_hash: item?.user_hash } } });

        if (student?.data?.rows?.[0]) {

          const studentReference = student?.data?.rows?.[0];

          if (item?.table) {
            api.put(`invitation-confirmation/${studentReference?._id?.toString()}/table`, { table: item?.table });
            addToast({ title: `${x + 1}/${items?.length} - Mesa de ${item?.name} atualizada`, type: 'info' });
          }

          if (item?.vip_category) {
            api.put(`invitation-confirmation/${studentReference?._id?.toString()}/vip_category`, { vip_category: item?.vip_category });
            addToast({ title: `${x + 1}/${items?.length} - Categoria VIP de ${item?.name} atualizada`, type: 'info' });
          }


        }
        else {
          addToast({ title: `${item?.name} não identificado`, type: 'error' });
        }


      }


      x += 1;
    }


    addToast({ title: 'Atualização concluída', type: 'success' });

    removeModal('table')


  }


  const setCallback = async (
    data: Record<string, any>,
    formRef: React.RefObject<FormHandles>,
  ): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('file', data.image)
      const response = await api.post(`/converter/xlsx-to-json`, formData);

      if (response.status !== 200) {
        return addToast({ type: 'error', title: 'Erro ao enviar' });
      }

      const items: Record<string, any>[] = [];

      response?.data?.rows.map(i => {

        items.push({
          user_hash: i?.['CÓDIGO DO USUÁRIO'] || '',
          category_id: i?.CATEGORIA || '',
          name: i?.NOME || '',

          company: i?.EMPRESA || '',
          position: i?.CARGO || '',
          vip_category: i?.['CATEGORIA VIP'] || '',
          table: i?.MESA || '',
        })

      })


      addModal({
        key: 'table',
        theme: 'whiteModal',
        title: '', content: <>
          <div className='row-to-column gap pad'>
            <button className='greenButton2' onClick={() => sendConfirmation(items)}>Atualizar</button>
          </div>
          <table className='table'>

            <tbody>
              <tr><td>CATEGORIA</td><td style={{ fontWeight: 'bold' }}>MESA</td><td style={{ fontWeight: 'bold' }}>CATEGORIA VIP</td><td>NOME</td> <td>EMPRESA</td><td>CARGO</td></tr>
              {items.map(i => {
                return <tr>
                  <td>{i?.category_id}</td>
                  <td>{i?.table}</td>
                  <td>{i?.vip_category}</td>
                  <td>{i?.name}</td>


                  <td>{i?.company}</td>
                  <td>{i?.position}</td>
                </tr>
              })}
            </tbody>


          </table>
        </>
      })



    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
        return;
      }

      return addToast({ type: 'error', title: err?.response?.data?.error || err?.response?.data?.message });
    }
  };

  const handleCreate = (): void => {
    const content = (
      <FormComponent schema={{
        image: {
          model: 'uploadImage',
          type: 'upload',
          name: 'image',
          label: 'Imagem',
        }
      }} setCallback={setCallback} />
    );
    if (content) {
      const keyModal = addModal({ title: 'Adicionar convidados', content, key, theme: "whiteModal" });
    }
  };




  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
    <>
      <button className="lineIcon" type="button" onClick={handleCreate}>
        <FiRewind />
      </button> </>
  );

  return moduleUpdate(lineData);
}
